
import User from './modules/UserApi'
import Category from './modules/CategoryApi'
import Department from './modules/DepartmentApi'
import Execution from './modules/ExecutionApi'

export default {
  Execution,
  Department,
  Category,
  User,
}